import React from 'react';
import { IonPage } from '@ionic/react';
import Login from "../components/Login";
import { useParams } from 'react-router-dom';
import history from '../helpers/history';

interface ParamTypes {
  type: string
}

const ReLogin = () => {
  const { type } = useParams<ParamTypes>()
  const afterLogin: string = history.location.state as string

  return (
    <IonPage className="cheap_desktop">
      <Login page={type} afterLogin={afterLogin}/>
    </IonPage>
  );
}

export default ReLogin